import errorMessages from "utils/validation/errorMessages";
import { emailSchema } from "utils/validation/validationHelpers";
import { array, object, string } from 'yup';

const designationFormSchema = object().shape({
  title: string().required(errorMessages.required),
  description: string().required(errorMessages.required),
});

export default designationFormSchema;